import { CSSObject } from "styled-components";
import { vfxTheme } from "../VFX-UI/Theme/theme";

interface IconStyles {
    viewIcon: CSSObject;
    container: CSSObject;
    iconText: CSSObject;
    deleteIcon: CSSObject;
    flex: CSSObject;
}

const useIconStyles = (): IconStyles => {
    
    return {
        container: { display: "flex", alignItems: "center" },
        viewIcon: {
            color: vfxTheme.palette.primary.main,
            marginRight: vfxTheme.spaceUnits.sp01,
            fontSize: "1.5em"
        },
        iconText: {
            color: vfxTheme.palette.text.primary,
            marginLeft: vfxTheme.spaceUnits.sp01,
            fontSize: "1em",
            fontFamily: vfxTheme.fontFamily
        },
        deleteIcon: {
            color: vfxTheme.palette.secondary.main,
            marginRight: vfxTheme.spaceUnits.sp01,
            fontSize: "1.15em"
        },
        flex: {
            display: "flex",
        },
    };
};

export default useIconStyles;
